import { FC, useEffect, useRef } from 'react'
import { useToggle } from 'react-use'
import { ReactComponent as BellIcon } from '@interface-images/bell.svg'
import { useAppDispatch } from '@hooks/useAppDispatch'
import StoreTags from '@enums/StoreTags'
import { coursesApi } from '@services/courses'
import { useGetUnreadNotificationsCountQuery } from '@services/notifications'
import { POOLING_NOTIFICATIONS_INTERVAL } from '@const/pooling'
import OutsideClick from '@organisms/OutsideClick'
import { Container, Wrapper } from './styled'
import Counter from './Counter'
import List from './List'

const Bell: FC = () => {
  const dispatch = useAppDispatch()
  const previousUnreadNotificationsCount = useRef<number>()
  const { data: unreadNotificationsCount } =
    useGetUnreadNotificationsCountQuery(undefined, {
      pollingInterval: POOLING_NOTIFICATIONS_INTERVAL,
    })

  useEffect(() => {
    if (unreadNotificationsCount === undefined) return

    if (
      previousUnreadNotificationsCount.current !== undefined &&
      unreadNotificationsCount > previousUnreadNotificationsCount.current
    ) {
      dispatch(
        coursesApi.util.invalidateTags([
          StoreTags.COURSES,
          StoreTags.COURSE,
          StoreTags.MY_COURSES,
          StoreTags.MY_COURSE,
        ])
      )
    }

    previousUnreadNotificationsCount.current = unreadNotificationsCount
  }, [dispatch, unreadNotificationsCount])

  const [listIsVisible, toggleListIsVisible] = useToggle(false)
  const bellRef = useRef<HTMLDivElement>(null)

  return (
    <OutsideClick onOutsideClick={() => toggleListIsVisible(false)}>
      <Container>
        <Wrapper ref={bellRef} onClick={toggleListIsVisible}>
          <BellIcon />
          <Counter length={unreadNotificationsCount ?? 0} />
        </Wrapper>
        {listIsVisible && (
          <List
            listIsVisible={listIsVisible}
            toggleListIsVisible={toggleListIsVisible}
            anchorRef={bellRef}
          />
        )}
      </Container>
    </OutsideClick>
  )
}

export default Bell
